import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {HomeHeaderSection, FAQSection, Header, Footer} from '../../components';
import YoutubeVideoEmbed from 'epic-react-common/src/components/YoutubeVideoEmbed';
import {getLocale} from 'epic-common/src/locale';
import styles from './Overview.pcss';
import overviewActions from '../../actions/overview.actions';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    overviewState: state.get('overview').toJS(),
    userState: state.get('user').toJS(),
    influencerState: state.get('influencer').toJS(),
    configState: state.get('config').toJS()
});

const mapDispatchToProps = dispatch => ({
    getOverviewData: lang => {
        dispatch(overviewActions.getHome(lang));
    }
});

@connect(
    mapStateToProps,
    mapDispatchToProps
)
class Overview extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        getOverviewData: PropTypes.func,
        overviewState: PropTypes.object,
        influencerState: PropTypes.object,
        userState: PropTypes.object,
        configState: PropTypes.object
    };

    componentDidMount() {
        const params = {
            locale: getLocale()
        };

        this.props.getOverviewData(params);
    }

    itemRenderer = item => {
        let content = null;
        switch (item.type) {
            case 'youtube':
                content = (
                    <div className={styles.carouselYoutube}>
                        <YoutubeVideoEmbed
                            video={item.content}
                            play={false}
                            mute={true}
                            launcher={false}
                        />
                    </div>
                );
                break;
            case 'image':
            default:
                content = (
                    <div>
                        <img alt={item.title} src={item.imageUrl} />
                        <h2>{item.title}</h2>
                    </div>
                );
                break;
        }

        return (
            <div className={styles.carouselItem} onClick={() => console.log(item)}>
                {content}
            </div>
        );
    };

    convertCarousel = items => {
        const entries = [];
        if (items) {
            items.map((item, key) => {
                if (item.image) {
                    entries.push({
                        id: key + 1,
                        type: 'image',
                        title: item.image.title,
                        imageUrl: item.image.content,
                        mobileImageUrl: item.image.contentMobile,
                        tabletImageUrl: item.image.contentTablet
                    });
                } else if (item.youtube) {
                    entries.push({
                        id: key + 1,
                        type: 'youtube',
                        title: item.youtube.title,
                        content: item.youtube.content
                    });
                }
                return entries;
            });
        }
        return entries;
    };

    render() {
        const {overviewState, influencerState, userState, messages, configState} = this.props;

        const {affiliateAccount} = influencerState;
        const {accountInfo} = userState;

        const {epicFooter} = configState;
        //console.log(configState);

        return (
            <div>
                <Header
                    messages={messages}
                    headerClass={styles.header}
                    affiliateAccount={affiliateAccount}
                    accountInfo={accountInfo}
                    configState={configState}
                />
                <HomeHeaderSection
                    {...this.props}
                    sectionData={overviewState}
                    affiliateAccount={affiliateAccount}
                    isLoggedIn={accountInfo.isLoggedIn}
                />

                <FAQSection {...this.props} sectionData={overviewState} />

                <Footer content={epicFooter} messages={messages} accountInfo={accountInfo} />
            </div>
        );
    }
}

export default withRouter(Overview);
